// Ruta: apps/dashboard/src/App.tsx
import React, { Suspense, Component } from 'react'
import type { ReactNode, ErrorInfo } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { FullPageSpinner } from '@heyshaker/ui'
import { AppRouter } from './router.js'

// ─── Error boundary ──────────────────────────────────────────────────────────

interface EBProps { children: ReactNode }
interface EBState { error: Error | null }

class ErrorBoundary extends Component<EBProps, EBState> {
  state: EBState = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen gap-4 p-8 text-center">
          <h1 className="text-xl font-bold text-red-600">Algo salió mal</h1>
          <p className="text-sm text-muted-foreground max-w-md">
            {this.state.error.message}
          </p>
          <pre className="text-xs text-left bg-muted p-4 rounded-md max-w-2xl overflow-auto max-h-48">
            {this.state.error.stack}
          </pre>
          <button
            onClick={() => { this.setState({ error: null }); window.location.reload() }}
            className="px-4 py-2 bg-primary text-white rounded-md text-sm"
          >
            Recargar
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

// ─── App ─────────────────────────────────────────────────────────────────────

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<FullPageSpinner />}>
          <AppRouter />
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  )
}
